import { Injectable, inject } from '@angular/core';
import { SessionService } from './session.service';
import { Role } from 'src/app/pages/anvandare/anvandare.models';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  private sessionService = inject(SessionService);

  private adminRoles = ['SR20', 'SR21', 'SR22'];

  public hasRole(roles: Role[]) {
    return roles.some(role => this.sessionService.session.getValue()?.roles.includes(role));
  }

  public roleIsAdmin(role: string) {
    return this.adminRoles.includes(role);
  }

  public isInternSuperUser() {
    return  this.sessionService.session.getValue()?.roles.includes(Role.SuperanvandareIntern);
  }
}
